<template>
    <v-bottom-navigation
        v-if="$vuetify.breakpoint.mdAndDown"
        app
        color="#8F8F8F"
        fixed
        class="bottom-navigatoin"
        :height="height"
        :horizontal="!!$vuetify.breakpoint.smAndUp"
    >
        <div style="height:50px; display: flex; justify-content: center; width: 100%;">
            <v-btn
                v-for="item in items"
                :key="`bottomNavigationItem_${item.text}`"
                :to="item.route"
            >
                <span>{{item.text}}</span>
                <component :is="item.icon" />
            </v-btn>
        </div>
    </v-bottom-navigation>
</template>

<script>
    export default {
        name: 'BottomNavigation',

        props: {
            items: { type: Array },
        },

        data: () => ({
            //
        }),

        computed: {
            height() {
                if (['iPhone', 'iPad', 'iPod'].includes(navigator.platform)) {
                    return 70
                } else {
                    return 50
                }
            },
        },
    }
</script>

<style>
    .bottom-navigatoin {
        background-color: #FFF;
    }
    .bottom-navigatoin .v-btn--active{
        color: #DA251C !important;
    }
    .bottom-navigatoin .v-btn--active svg{
        color: #DA251C !important;
    }
    .bottom-navigatoin .v-btn--active::before{
        background-color: unset !important;
    }
    .bottom-navigatoin-icon-active .v-btn:before{
        opacity: 0 !important;
    }
</style>
